import React from 'react';

interface MonogramProps {
  name?: string;
  initials?: string;
  lg?: boolean;
  size?: number; // px — overrides width/height/font-size (e.g. 36 for nav, 40 for convo list)
  style?: React.CSSProperties;
}

export function getInitials(name?: string): string {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

const Monogram: React.FC<MonogramProps> = ({ name, initials, lg, size, style }) => {
  const text = initials || getInitials(name);
  const sizeStyle: React.CSSProperties = size
    ? { width: size, height: size, fontSize: Math.round(size * 0.39) }
    : {};
  return (
    <div className={`monogram${lg ? ' lg' : ''}`} style={{ ...sizeStyle, ...style }}>
      {text}
    </div>
  );
};

export default Monogram;
